import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AdminFreeResponseQuestion,
  AdminMcqQuestion,
  QuestionType,
} from "../types/adminQuestionTypes";
import {
  retrieveAdminFRQAction,
  retrieveAdminMCQAction,
} from "../middleware/adminQuestionMiddleware";
import { initialPagination, PaginationType } from "../../types/paginationType";
import { DataStatus } from "../types/LearnTypes";

export type AdminQuestionState = {
  MCQ: AdminMcqQuestion[];
  FRQ: AdminFreeResponseQuestion[];
  mcqStatus: DataStatus;
  frqStatus: DataStatus;
  adminFrqPagination: PaginationType;
  adminMcqPagination: PaginationType;
};

type mcqPayloadType = {
  mcqData: AdminMcqQuestion[];
  pagination: PaginationType;
  message?: string;
};

type frqPayloadType = {
  freeResponseData: AdminFreeResponseQuestion[];
  pagination: PaginationType;
  message?: string;
};

const initialState = {
  MCQ: [],
  FRQ: [],
  mcqStatus: DataStatus.loading,
  frqStatus: DataStatus.loading,
  adminFrqPagination: initialPagination,
  adminMcqPagination: initialPagination,
};

const adminQuestionSlice = createSlice({
  name: "adminQuestion",
  initialState: initialState as AdminQuestionState,
  reducers: {
    setMcq: (state, action: PayloadAction<AdminMcqQuestion[]>) => {
      state.MCQ = action.payload;
    },
    setFrq: (state, action: PayloadAction<AdminFreeResponseQuestion[]>) => {
      state.FRQ = action.payload;
    },
    setQuestionStatus: (
      state,
      action: PayloadAction<{ type: QuestionType; status: DataStatus }>
    ) => {
      const { type, status } = action.payload;
      if (type === QuestionType.MCQ) {
        state.mcqStatus = status;
        if (status === DataStatus.failed) {
          state.MCQ = [];
        }
      } else if (type === QuestionType.FRQ) {
        state.frqStatus = status;
        if (status === DataStatus.failed) {
          state.FRQ = [];
        }
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(
      retrieveAdminMCQAction.fulfilled,
      (state, action: PayloadAction<mcqPayloadType>) => {
        state.MCQ = action.payload.mcqData;
        state.adminMcqPagination = action.payload.pagination;
      }
    );
    builder.addCase(
      retrieveAdminFRQAction.fulfilled,
      (state, action: PayloadAction<frqPayloadType>) => {
        state.FRQ = action.payload.freeResponseData;
        state.adminFrqPagination = action.payload.pagination;
      }
    );
  },
});

export const { setMcq, setFrq, setQuestionStatus } = adminQuestionSlice.actions;

export default adminQuestionSlice.reducer;
